"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const plugin_manager_service_1 = require("../../../../service/plugin-manager.service");
const _ = require("lodash");
class ItemsComponent {
    constructor(pluginManager) {
        this.pluginManager = pluginManager;
        this.context = null;
        this.type = 'content';
        this.items = null;
        this.plugin = null;
        let me = this;
        this.plugin = {
            id: 999,
            meta: {
                category: 'preview'
            },
            hideDelete: true,
            hideHeader: true,
            item: null,
            controller: null,
            controls: [],
            getLabel: function () { return 'preview'; },
            refresh: function () { },
            save: function () { },
            has: function () { return false; },
            linearScale: function () { },
            goto: function (p) {
                console.log('goto() !!!!!!!!!!!', p);
            },
            show: function (p) {
                console.log('show() !!!!!!!!!!!', p);
            },
            hide: function (p) {
                console.log('hide() !!!!!!!!!!!', p);
            },
            startProcess: function (p) {
                me.startProcess(p);
            },
        };
    }
    ngOnInit() {
        console.log('++', this.context);
        if (this.context) {
            let state = this.context.state.state;
            let panels = this.context.props['panels'];
            console.log('++++', state, panels);
            if (panels) {
                console.log('++++++', this.type, panels[state]);
                if (panels[state] && panels[state][this.type]) {
                    console.log('++++++++', panels[state][this.type]);
                    this.items = panels[state][this.type];
                    this.populatePluginController(this.items);
                }
            }
        }
    }
    populatePluginController(items) {
        let these = [];
        items.forEach(i => {
            let a = _.cloneDeep(i);
            let t = '';
            if (i && i.label_token) {
                t = i.label_token;
            }
            a.name = this.slugify(t);
            these.push(a);
        });
        this.plugin.controls = these;
        return true;
    }
    ngOnDestroy() {
        this.plugin = null;
    }
    endProcess(p = null) {
    }
    startProcess(p = null) {
        let me = this.context.state;
        let process = null;
        if (p['process']) {
            let process_uid = p['process'];
            let find = this.context.processes.find(pp => pp.uid == process_uid);
            if (find) {
                process = find;
            }
        }
        console.log('startProcess() !!!!!!!!!!!', process, p, this.context);
        if (process) {
            if (process.state.state !== 'blank') {
                console.log('startProcess() RESET');
                if (process.state.can('cancel')) {
                    console.log('@@ ERROR can\'t start a processing that\'s already running');
                }
                else if (process.state.can('reset')) {
                    process.state.reset();
                }
            }
            console.log('startProcess() OPEN');
            me.sm.delegate();
            process.state.start();
        }
    }
    slugify(text) {
        return text
            .toString()
            .normalize('NFD') // split an accented letter in the base letter and the acent
            .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
            .toUpperCase()
            .trim()
            .replace(/\s+/g, '_')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '_');
    }
    ;
}
exports.ItemsComponent = ItemsComponent;
